import styled from "styled-components";

export const TabsLayout = styled.div`
  &&& {
    @media not print {
      display: flex;
      align-items: stretch;
      height: 100%;
      width: 100%;
      position: absolute;
      flex-direction: column;
    }
  }
`;

export const TabsWrapper = styled.div`
  &&& {
    padding: 0 9px;
    background-color: #f7f7f7;
    border-bottom: solid 1px #ccc;
    display: flex;

    ul {
      border: none;
      flex: 1;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        float: left;
        margin-bottom: -1px;
        display: block;
        position: relative;

        div {
          font-size: 16px;
          color: #333;
          -webkit-font-smoothing: antialiased;
          border: none;
          border-radius: 0;
          border-bottom: 1px none transparent;
          padding: 13px 15px 12px 15px;
          margin-right: 0;
          cursor: default !important;
          position: relative;
          display: block;
          user-select: none;

          @media (max-width: 550px) {
            font-size: 14px;
            padding-left: 10px;
            padding-right: 10px;
          }

          &:hover {
            border-color: transparent;
            background-color: #eeeeee;
          }
        }
      }

      li.active {
        div,
        div:hover,
        div:focus {
          color: #333;
          background: #f7f7f7;
          padding-bottom: 10px;
          border: none;
          border-bottom: solid 3px ${props => props.theme.primary};
          transition: border-bottom-color 0.2s;
          font-weight: bold;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Tabs/style.js